import { Swiper, SwiperOptions, Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

const init = ()=> {
	Swiper.use([Autoplay, EffectFade, Navigation, Pagination])
	const swiperParams: SwiperOptions = {
		slidesPerView: 1,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: '.js-video-banner-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.js-horizontal-banner--right',
			prevEl: '.js-horizontal-banner--left',
		},
		autoplay: {
			delay: 10000,
			disableOnInteraction: false
		},
	};
	const swiper = new Swiper('.js-video-banner', swiperParams);
	setTimeout(()=>{ 
        
    }, 100);
    
}


export const bannerSlider = {
	init: init
};